import React, { Component } from 'react';

export default class AddFolder extends Component {

  constructor(props) {
    super(props);

    this.state = {
      folderName: ''
    };


    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.handleChangeFolder(this.state.folderName);
  }

  handleChange(event) {
    this.setState({folderName: event.target.value});
  }

  render() {
    return (
      <tr id="new-folder" className={this.props.hide ? "" : "selected open"}>
        <td colSpan="2">
          <i className="fa fa-folder fa-lg fa-fw"></i>
          <input type="text" placeholder="folder name" onChange={this.handleChange} />
          <button className="btn" onClick={this.handleSubmit}>Save</button>
          <button className="btn" onClick={() => this.props.handleCancel()}>Cancel</button>
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AddFolder.js